jQuery( function($){

    $('.js-interes__btn').each(function () {
        var $this = $(this);
        var $index = $this.index();
        var $interes = $this.closest('.js-interes');
        var $image = $interes.find('.js-interes__image').eq($index);

        $this.hover(
            function () { $image.show(); },
            function () { $image.hide(); }
        );
    });

});
